// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import { loop } from 'utilities/objects'
import { loopArray } from 'utilities/arrays'
import Link from 'components/Link/Link'
import FlagSvg from 'components/svg/logo/pathfinder-flag.svg'
import IconMinus from 'components/svg/map/minus-square-outline.svg'
import IconPlus from 'components/svg/map/plus-square-outline.svg'

class Flag extends React.Component {
	constructor() {
		super()

		this.state = {
			selectedSection: false,
			sections: [
				{
					id: 'red',
					title: 'The Colour Red',
					content: `Reminds us of Christ's sacrafice for us. <em>'For God so love the world that He gave His one and only son. That whoever believes in Him shall not Perish but have eternal life.' - John 3:16</em>`
				},
				{
					id: 'sides',
					title: 'The Three Sides of the Triangle',
					content: `Represent the completeness of the Godhead - Father, Son, Holy Spirit. This gives an impression of oneness - all the sides even and joined with the Pathfinder in the middle.`
				},
				{
					id: 'gold',
					title: 'The Gold Edges',
					content: `Gold is also used as a standard of measurement. When we listen to the news every night, the price of gold is reported, giving us the indication that this metal is worth something. The Pathfinder club has high standards to help us build strong and worthy characters for the kingdom of God. <em>'I counsel you to buy from me gold refined in the fire, so you can become rich.' - Rev. 3:18</em>`
				},
				{
					id: 'shield',
					title: 'The Shield',
					content: `In the scripture, God is often called the shield of his people. <br /><em>'Do not be afraid... I am your shield.' - Gen. 15:1 </em><br /><em>'...Take up the shield of faith, with which you can extinguish all the flaming arrows of the evil one.' - Eph. 6:16 </em>`
				},
				{
					id: 'sword',
					title: 'The Sword',
					content: `The sword is a symbol of weapons used in warfare. We are in a battle against sin and our weapon is the Word of God. <em>'... The sword of the Spirit, which is the word of God.' - Eph. 6:7</em>`
				},
				{
					id: 'corners-white',
					title: 'The White Corners',
					content: `White is found in the 2nd and 3rd quarter of the Pathfinder flag. White is a symbol of purity. It translates the desire to have the righteousness of Christ’s life reflected in our lives. As John says <em>'all who are victorious will be clothed in white.' - Rev 3:5</em>`
				},
				{
					id: 'corners-blue',
					title: 'The Blue Corners',
					content: 'The blue is in the 1st and 4th quarter of the flag. Blue is recognised as a colour that represents loyalty. The blue in the flag reminds us that one of the purposes of the Pathfinder Club is to teach us to be loyal to our God, our country, our parents, our Church and our Club.'
				}
			]
		}
	}

	handleClickNavItem = ( e ) => {
		this.setState( {
			selectedSection: e.currentTarget.getAttribute( 'data-id' )
		} )
	}

	render() {
		const { sections, selectedSection } = this.state
		const className = `interactive-flag is-${selectedSection}`

		return (
			<div className={ className }>
				<div className="-header">
					<h2>Explore the Elements of the Flag</h2>

					<Link to="/principles-of-pathfindering" className="button -small">Back</Link>
				</div>

				<div className="-inner">
					<div className="-nav">
						{ loopArray( sections, ( key, item ) => {
							let className = item.id == selectedSection ? '-item is-selected' : '-item'

							return (
								<div className={ className } onClick={ this.handleClickNavItem } data-id={ item.id } key={ key }>{ item.title }</div>
							)
						} ) }
					</div>

					<div className="-content">
						<div className="-svg">
							<FlagSvg />
						</div>

						<div className="-text">
							{ loopArray( sections, ( key, item ) => {
								let className = item.id == selectedSection ? '-item is-selected' : '-item'

								return (
									<div className={ className } key={ key }><p dangerouslySetInnerHTML={ { __html: item.content } } /></div>
								)
							} ) }
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps )( Flag )



// WEBPACK FOOTER //
// ./components/Flag/Flag.jsx